import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { NotificationState, } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { Subject, } from 'rxjs';
import { map } from 'rxjs/operators';
export var NotificationSeverity;
(function (NotificationSeverity) {
    NotificationSeverity[NotificationSeverity["Info"] = 0] = "Info";
    NotificationSeverity[NotificationSeverity["Success"] = 1] = "Success";
    NotificationSeverity[NotificationSeverity["Warn"] = 2] = "Warn";
    NotificationSeverity[NotificationSeverity["Error"] = 3] = "Error";
    NotificationSeverity[NotificationSeverity["Fatal"] = 4] = "Fatal";
})(NotificationSeverity || (NotificationSeverity = {}));
var AlertsService = /** @class */ (function (_super) {
    tslib_1.__extends(AlertsService, _super);
    function AlertsService(http) {
        var _this = _super.call(this, http, MapperService.alertMap) || this;
        _this.count$ = new Subject();
        _this._endpoint = '/odata/Alerts';
        _this._alertCount = 0;
        return _this;
    }
    AlertsService.prototype.getUnreadCount = function () {
        var _this = this;
        return this._http.get(this._endpoint + "/UiPath.Server.Configuration.OData.GetUnreadCount")
            .pipe(map(function (res) {
            var count = res.value;
            _this._alertCount = count;
            return count;
        }));
    };
    AlertsService.prototype.markAsRead = function (ids) {
        var _this = this;
        var payload = { ids: ids };
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.MarkAsRead", payload)
            .pipe(map(function (res) {
            var count = res.value;
            _this._alertCount = count;
            _this.count$.next(count);
        }));
    };
    AlertsService.prototype.getUnreadList = function (top) {
        var options = {
            filter: {
                State: {
                    eq: NotificationState.Unread.toString(),
                },
            },
            top: top,
            orderBy: ['Severity desc', 'CreationTime desc'],
        };
        return this.get(options);
    };
    AlertsService.prototype.incrementCount = function () {
        this.count$.next(this._alertCount + 1);
    };
    return AlertsService;
}(ODataService));
export { AlertsService };
